import {GetMboProgramsParams} from '@/api/api';
import {UseQueryResult} from '@tanstack/react-query';
import {useCallback} from 'react';
import {Program, useGetPrograms} from './useGetPrograms';

type useGetSingleProgramParams = GetMboProgramsParams & {
  programId?: string | null;
};

export const useGetSingleProgram = ({siteId, programId}: useGetSingleProgramParams) => {
  const select = useCallback((data: Program[]) => data.find((program) => program.programId === programId), [programId]);

  return useGetPrograms({siteId, select}) as UseQueryResult<Program>;
};
